module.exports = __webpack_public_path__ + "img/discover.d5e3631.png";